import { ExpandMore } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useCallback, useState } from 'react';

const useCollapse = (name: string, initial = false) => {
  const initialState = localStorage.getItem(name) ? localStorage.getItem(name) === 'true' : initial;
  const [isCollapsed, setIsCollapsed] = useState<boolean>(initialState);

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(name, String(next));
      return next;
    });
  }, [name]);

  // Memoised so the component reference stays stable across parent re-renders
  // (e.g. 1 Hz countdown ticks). Without this, React would unmount and remount
  // the IconButton each tick, dropping the CSS :hover state mid-hover.
  const CollapseButton = useCallback(
    () => (
      <IconButton onClick={toggleCollapse}>
        {isCollapsed ? <ExpandMore sx={{ transform: 'rotate(-90deg)' }} /> : <ExpandMore sx={{ transform: 'rotate(90deg)' }} />}
      </IconButton>
    ),
    [isCollapsed, toggleCollapse]
  );

  return { isCollapsed, toggleCollapse, CollapseButton };
};

export default useCollapse;
